import styles from "./index.css";
import content from "app-content";

const QR_CODE_URL =
  "https://content.asos-media.com/-/media/app-download/app-download-qr-code.png";

const AppDownloadBanner = () => {
  const handleQrCodeError = () => {
    if (typeof window !== "undefined" && window.newrelic) {
      window.newrelic.noticeError(
        new Error("App download QR code failed to load"),
        { qrCodeUrl: QR_CODE_URL }
      );
    }
  };

  return (
    <div className={styles.appDownloadBannerContainer}>
      <div className={styles.appDownloadBanner}>
        <h2 className={styles.bannerHeading}>
          {content.download_the_app_cta_title}
        </h2>

        <div className={styles.qrCodeContainer}>
          <img
            src="https://content.asos-media.com/-/media/app-download/app-download-qr-code.png"
            alt={content.app_download_qr_alt}
            className={styles.qrCode}
            loading="lazy"
            width="176"
            height="176"
            onError={handleQrCodeError}
          />
          <p className={styles.bannerTagline}>
            {content.saved_items_app_download_banner_description}
          </p>
        </div>

        <div className={styles.bannerRating}>
          <span
            className={styles.starsContainer}
            aria-label="5 stars"
            role="img"
          >
            {Array.from({ length: 5 }).map((_, index) => (
              <span key={index} className={styles.star} aria-hidden="true" />
            ))}
          </span>
          <span className={styles.downloadsText}>
            {content.order_confirmation_app_download_banner_number_of_downloads}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
